<template>
  <Teleport to="body">
    <div
      class="z-notification pointer-events-none fixed top-4 right-4 flex flex-col gap-3"
      :aria-live="livePoliteness"
      aria-relevant="additions text"
      aria-atomic="true"
    >
      <TransitionGroup
        tag="div"
        class="flex flex-col gap-3"
        enter-active-class="transform transition duration-200 delay-100"
        enter-from-class="opacity-0 -translate-y-6"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transform transition duration-100"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-4"
        move-class="transition duration-200"
      >
        <NotificationToast
          v-for="item in displayNotifications"
          :key="item.id"
          :id="item.id"
          :message="item.message"
          :type="item.type"
          :duration-ms="item.durationMs"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import NotificationToast from './NotificationToast.vue';
import { displayNotifications } from './index';

const livePoliteness = computed(() =>
  displayNotifications.value.some((n) => n.type === 'error')
    ? 'assertive'
    : 'polite'
);
</script>
